function debounce(fn, wait) {
  let timeout = null;

  const debounced = function (...args) {
    const later = () => {
      timeout = null;

      fn.apply(this, args);
    };

    clearTimeout(timeout);
    timeout = setTimeout(later, wait);

    if (!timeout) {
      fn.apply(this, args);
    }
  };

  debounced.cancel = () => {
    clearTimeout(timeout);
    timeout = null;
  };

  return debounced;
}

export default debounce;
